module.exports = __webpack_public_path__ + "img/forbidden.a081a782.svg";